import PropTypes from 'prop-types'
import React, { Component } from 'react'

let _scrollBarWidth = null

function getScrollBarWidth() {
    if (_scrollBarWidth === null) {
        const inner = document.createElement('p')
        inner.style.width = '100%'
        inner.style.height = '200px'

        const outer = document.createElement('div')
        outer.style.position = 'absolute'
        outer.style.top = '0px'
        outer.style.left = '0px'
        outer.style.visibility = 'hidden'
        outer.style.width = '200px'
        outer.style.height = '150px'
        outer.style.overflow = 'hidden'
        outer.appendChild(inner)

        document.body.appendChild(outer)
        const w1 = inner.offsetWidth
        outer.style.overflow = 'scroll'
        let w2 = inner.offsetWidth

        if (w1 === w2) {
            w2 = outer.clientWidth
        }

        document.body.removeChild(outer)

        _scrollBarWidth = (w1 - w2)
    }

    return _scrollBarWidth
}

export default function withScrollBarWidth(ChildComponent) {

    return class WithScrollBarWidthWrapper extends Component {
        static propTypes = {
            scrollBarWidth: PropTypes.number
        }

        constructor(props) {
            super(props)
        }

        render() {
            return (
                <ChildComponent scrollBarWidth={getScrollBarWidth()} {...this.props} />
            )
        }
    }
}



// WEBPACK FOOTER //
// src/containers/high-order-components/with-scroll-bar-width.js